import 'jquery-smooth-scroll';

export default () => {
    $(document).ready(function() {
        $('a.gl-scroll-down').smoothScroll();
    });
};



/** WEBPACK FOOTER **
 ** ./assets/src/js/smoothScroll/smoothScrollInit.js
 **/